var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OrgUnitsFilterSelect } from '@web/components/Filters/Elements/OrgUnits';
import { PeriodFilter } from '@web/components/Filters/Elements/Period';
import { UsersFilterSelect } from '@web/components/Filters/Elements/Users';
import { FiltersWidget } from '@web/components/Filters/Elements/Widget';
export function StickyFilters(_a) {
    var _b = _a.orgUnits, orgUnits = _b === void 0 ? {} : _b, _c = _a.users, users = _c === void 0 ? {} : _c, _d = _a.period, period = _d === void 0 ? {} : _d, additionalFilters = _a.additionalFilters;
    return (_jsxs(FiltersWidget, { children: [_jsx(OrgUnitsFilterSelect, __assign({}, orgUnits)), _jsx(UsersFilterSelect, __assign({}, users)), _jsx(PeriodFilter, __assign({}, period)), additionalFilters] }));
}
export default StickyFilters;
